/**
 * Generates a unique ID.
 */
export function uniqueId() {
  return Array.from(crypto.getRandomValues(new Uint32Array(3)))
    .map((v) => v.toString(36))
    .join('');
}
